import alt from 'components/Dispatcher';
import PorderSource from 'sources/PorderSource';
import PorderActions from 'actions/PorderActions';

export class PorderStore{
  constructor() {
    this.state = {
      first: 0,
      maxCount: 20,
      status: 0,
      porders: [],
      waitPayPorders: [],
      waitGoPorders: [],
      waitCommentPorders: [],
      waitTeamPorders: [],
      loading: false,
      waitPayPordersLoading: false,
      waitGoPordersLoading: false,
      waitCommentPordersLoading: false,
      waitTeamPordersLoading: false,
      hasMore: true,
      waitPayPordersHasMore: true,
      waitGoPordersHasMore: true,
      waitCommentPordersHasMore: true,
      waitTeamPordersHasMore: true,
      offset: 0,
      waitPayPordersOffset: 0,
      waitGoPordersOffset: 0,
      waitCommentPordersOffset: 0,
      waitTeamPordersOffset: 0,
      porderId: '',
      params: {},
      porder: {}
    };
    this.registerAsync(PorderSource);
    this.bindListeners({
      handleFetchPorders: PorderActions.FETCH_PORDERS,
      handleUpdatePorders: PorderActions.UPDATE_PORDERS,
      handleFetchPorder: PorderActions.FETCH_PORDER,
      handleUpdatePorder: PorderActions.UPDATE_PORDER,
      handleFetchLoading: PorderActions.FETCH_LOADING,
      handleSetData: PorderActions.SET_DATA,
      handleFetchSuccess: PorderActions.FETCH_SUCCESS,
      handleFetchError: PorderActions.FETCH_ERROR,
      handleRefreshPorder: PorderActions.REFRESH_PORDER
    });
  }
  handleFetchPorders() {
    let status = this.state.status;
    if(status == 0){
      this.setState({first:this.state.porders.length + 1});
    }else if(status == 1){
      this.setState({first:this.state.waitPayPorders.length + 1});
    }else if(status == 2){
      this.setState({first:this.state.waitTeamPorders.length + 1});
    }else if(status == 3){
      this.setState({first:this.state.waitGoPorders.length + 1});
    }else if(status == 4){
      this.setState({first:this.state.waitCommentPorders.length + 1});
    }
    this.getInstance().getRemotePorders();
  }
  handleUpdatePorders({status,porders}) {
    if(status == 0){
      let oldPorders = this.state.porders;
      porders = oldPorders.concat(porders)
      this.setState({porders:porders});
    }else if(status == 1){
      let oldPorders = this.state.waitPayPorders;
      porders = oldPorders.concat(porders)
      this.setState({waitPayPorders:porders});
    }else if(status == 2){
      let oldPorders = this.state.waitTeamPorders;
      porders = oldPorders.concat(porders)
      this.setState({waitTeamPorders:porders});
    }else if(status == 3){
      let oldPorders = this.state.waitGoPorders;
      porders = oldPorders.concat(porders)
      this.setState({waitGoPorders:porders});
    }else if(status == 4){
      let oldPorders = this.state.waitCommentPorders;
      porders = oldPorders.concat(porders)
      this.setState({waitCommentPorders:porders});
    }
  }
  handleFetchPorder(id) {
    this.setState({porderid: id});
    this.getInstance().getRemotePorder();
  }
  handleRefreshPorder() {
    this.getInstance().getRemotePorders();
    this.getInstance().getRemotePorder();
  }
  handleUpdatePorder(porder) {
    this.setState({porder});
  }
  handleFetchLoading() {
    this.setState({loading: true});
  }
  handleSetData(data) {
    this.setState(data)
  }
  handleFetchSuccess() {
    this.setState({loading: false});
  }
  handleFetchError(error) {
    this.setState({loading: false});
  }

}

export default alt.createStore(PorderStore, 'PorderStore');



// WEBPACK FOOTER //
// ./src/stores/PorderStore.js